(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["c-cards"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    const sliders = document.querySelectorAll('[data-cards-slider]');
    
    sliders.forEach(slider => {
      const section = slider.closest('.c-cards');
      const pagination = section.querySelector('[data-cards-pagination]');
      const dots = pagination ? pagination.querySelectorAll('.c-cards__pagination-dot') : [];
      const cards = slider.querySelectorAll('.c-card');
      
      if (dots.length === 0 || cards.length === 0) return;
      
      // Update active dot based on scroll position
      function updateActiveDot() {
        const scrollLeft = slider.scrollLeft;
        const cardWidth = cards[0].offsetWidth;
        const activeIndex = Math.round(scrollLeft / cardWidth);
        
        dots.forEach((dot, index) => {
          if (index === activeIndex) {
            dot.classList.add('active');
          } else {
            dot.classList.remove('active');
          }
        });
      }
      
      // Scroll to card on dot click
      dots.forEach((dot, index) => {
        dot.addEventListener('click', function() {
          const cardWidth = cards[0].offsetWidth;
          slider.scrollTo({
            left: cardWidth * index,
            behavior: 'smooth'
          });
        });
      });
      
      // Listen to scroll events
      let scrollTimeout;
      slider.addEventListener('scroll', function() {
        clearTimeout(scrollTimeout);
        scrollTimeout = setTimeout(updateActiveDot, 50);
      });
      
      // Initialize
      updateActiveDot();
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["feature-carousel-brand"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    // Find all carousel wrappers with the class pattern
    const carousels = document.querySelectorAll('[id*="carousel-wrapper-"]');
    
    carousels.forEach(function(carousel) {
      if (!carousel) return;

      // Ensure infinite scroll by monitoring animation
      carousel.addEventListener('animationiteration', function() {
        // Animation will restart automatically due to infinite iteration
        console.log('Carousel animation cycle completed - continuing infinitely');
      });

      // Add performance optimization
      carousel.style.willChange = 'transform';
      
      // Ensure the animation never stops when visible
      const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            // Resume animation when visible
            carousel.style.animationPlayState = 'running';
          }
        });
      });
      
      observer.observe(carousel);
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-collection-sale"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('.quantity-form').forEach(function(form) {
  const decreaseBtn = form.querySelector('[data-action="decrease"]');
  const increaseBtn = form.querySelector('[data-action="increase"]');
  const qtyInput = form.querySelector('input[name="quantity"]');
  const addBtn = form.querySelector('.btn-drawer-add');
  const variantId = form.querySelector('input[name="id"]').value;

  // Load saved quantity from localStorage
  const savedQty = localStorage.getItem('qty_' + variantId);
  if(savedQty) qtyInput.value = savedQty;

  decreaseBtn.addEventListener('click', function() {
    let current = parseInt(qtyInput.value);
    if(current>0) qtyInput.value = current-1;
    localStorage.setItem('qty_' + variantId, qtyInput.value);
  });

  increaseBtn.addEventListener('click', function() {
    let current = parseInt(qtyInput.value);
    qtyInput.value = current+1;
    localStorage.setItem('qty_' + variantId, qtyInput.value);
  });

  qtyInput.addEventListener('input', function() {
    if(parseInt(qtyInput.value) < 0) qtyInput.value = 0;
    localStorage.setItem('qty_' + variantId, qtyInput.value);
  });

  addBtn.addEventListener('click', function() {
    const qty = parseInt(qtyInput.value);
    if(qty <= 0){
      alert('Please select a quantity.');
      return;
    }

    fetch('/cart/add.js', {
      method:'POST',
      headers: {'Content-Type':'application/json'},
      body:JSON.stringify({items:[{id:variantId,quantity:qty}]})
    })
    .then(response=>response.json())
    .then(data=>{
      let feedback = document.createElement('div');
      feedback.className = 'added-feedback';
      feedback.innerText = 'Added to cart!';
      form.appendChild(feedback);
      setTimeout(()=>{ feedback.remove(); }, 2000);

      addBtn.style.transform = 'scale(0.95)';
      setTimeout(()=>{ addBtn.style.transform = 'scale(1)'; },150);

      if(window.theme && theme.cartDrawer){
        theme.cartDrawer.open();
        theme.cartDrawer.refresh();
      }

      localStorage.setItem('qty_' + variantId, qtyInput.value);
    });
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-auto-scroll"] && !Shopify.designMode) return;
  try {
    
  class HeroAutoScroll {
    constructor(section) {
      this.section = section;
      this.tracks = section.querySelectorAll('[class*="c-hero-auto-scroll__track--"]');
      this.observer = null;
      this.init();
    }

    init() {
      this.observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            this.tracks.forEach((track) => {
              track.style.animationPlayState = entry.isIntersecting ? 'running' : 'paused';
            });
          });
        },
        { threshold: 0.1 }
      );

      this.observer.observe(this.section);
      this.section._heroAutoScroll = this;
    }

    destroy() {
      if (this.observer) this.observer.disconnect();
    }
  }

  document.querySelectorAll('[data-sl-id="sl-section-hero-auto-scroll-v1"]').forEach((section) => {
    if (!section._heroAutoScroll) {
      new HeroAutoScroll(section);
    }
  });

  document.addEventListener('shopify:section:load', (event) => {
    const section = event.target.querySelector('[data-sl-id="sl-section-hero-auto-scroll-v1"]');
    if (section && !section._heroAutoScroll) {
      new HeroAutoScroll(section);
    }
  });

  document.addEventListener('shopify:section:unload', (event) => {
    const section = event.target.querySelector('[data-sl-id="sl-section-hero-auto-scroll-v1"]');
    if (section && section._heroAutoScroll) {
      section._heroAutoScroll.destroy();
      section._heroAutoScroll = null;
    }
  });

  } catch(e) { console.error(e); }
})();
})();
